import {RunningTime} from '@hconnect/common/types'
import {BOX_HEIGHTS} from '@hconnect/uikit'
import {CardBox, CardLinkWrapper} from '@hconnect/uikit/src/lib2'
import {useMediaQuery, useTheme} from '@mui/material'
import {KilnDowntimeByCategoryChartContainer} from '@widgets/downtime-analytics'
import {OperationHoursFromYesterdayContainer} from '@widgets/running-times'
import {Link} from 'react-router'

import {
  MajorOutageLeadEventsContainer,
  RcfaWeeklySummaryContainer,
  WorkOrdersByRevisionCodeYtdContainer
} from '../containers'
import {MajorOutageLeadDashboardLayout} from '../layout'

type Props = {
  plantId: string
  titleSlot?: React.ReactNode
  onEquipmentClick?: (equipmentId: string) => void
  renderRunningTimeTooltipFooter?: (rt: RunningTime) => React.ReactNode
  rcfaListHref?: string
  shiftSummaryHref?: string
  onEventClick?: () => void
  plantDowntimeHref?: string
}

export const MajorOutageLeadDashboard = ({
  plantId,
  titleSlot,
  onEquipmentClick,
  renderRunningTimeTooltipFooter,
  shiftSummaryHref,
  onEventClick,
  rcfaListHref,
  plantDowntimeHref
}: Props) => {
  const theme = useTheme()
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const kilnDowntimeChart = (
    <KilnDowntimeByCategoryChartContainer
      plantId={plantId}
      cardBoxSx={{height: BOX_HEIGHTS['M'], width: '100%'}}
      placeholderWrapperSx={{height: '100%'}}
    />
  )

  const rcfaWeeklySummary = (
    <RcfaWeeklySummaryContainer
      placeholderWrapperSx={{height: '100%'}}
      plantId={plantId}
      cardBoxSx={{height: BOX_HEIGHTS['M'], width: '100%'}}
    />
  )

  return (
    <MajorOutageLeadDashboardLayout
      titleSlot={titleSlot}
      operationHoursSlot={
        <OperationHoursFromYesterdayContainer
          plantId={plantId}
          onEquipmentClick={onEquipmentClick}
          cardBoxSx={{height: BOX_HEIGHTS['M'], width: '100%'}}
          isMobile={isSmallMobile}
          renderRunningTimeTooltipFooter={renderRunningTimeTooltipFooter}
        />
      }
      eventsSlot={
        <MajorOutageLeadEventsContainer
          plantId={plantId}
          shiftSummaryLink={shiftSummaryHref}
          onEventClick={onEventClick}
          isMobile={isSmallMobile}
          cardBoxSx={{height: BOX_HEIGHTS['M'], width: '100%'}}
        />
      }
      revisionCodesSlot={
        <WorkOrdersByRevisionCodeYtdContainer
          plantId={plantId}
          cardBoxSx={{height: BOX_HEIGHTS['M'], width: '100%'}}
        />
      }
      kilnDowntimeByCategorySlot={
        plantDowntimeHref ? (
          <CardLinkWrapper<typeof Link> component={Link} to={plantDowntimeHref}>
            {kilnDowntimeChart}
          </CardLinkWrapper>
        ) : (
          kilnDowntimeChart
        )
      }
      upcomingStoppagesSlot={
        <CardBox sx={{height: BOX_HEIGHTS['M'], width: '100%'}}>
          Upcoming stoppages codes placeholder
        </CardBox>
      }
      rcfaSummarySlot={
        rcfaListHref ? (
          <CardLinkWrapper href={rcfaListHref} data-test-id="rcfa-summary-card-link-to-maintain">
            {rcfaWeeklySummary}
          </CardLinkWrapper>
        ) : (
          rcfaWeeklySummary
        )
      }
    />
  )
}
